import React from 'react';
import { Card ,Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Mode = ({ setGameMode, setGameModal, showGameModal }) => {
  const handleButtonClick = (value) => {
    setGameMode(value);
    setGameModal(false);
  };

  const handleModalClose = () => {
    window.location.href = '/';
  };

  return (
    <Modal
      size='lg'
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showGameModal}
      onHide={handleModalClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
            Spielmodus
        </Modal.Title>
      </Modal.Header>



<Modal.Body>
        <Container className='text-center'>
          <Row className="justify-content-center mb-3">
            <Col xs="12" sm="6" md="6" lg="6">
              <Card className="custom-card">
                <Card.Body>
                  <Card.Text>
                    "Spielen Sie als Projektmanager mit klar definierter Zeitbegrenzung. Nach Ablauf der Zeit sind keine weiteren Tätigkeiten möglich. Das Projekt endet Sofort."
                  </Card.Text>
                  <Button
                    value="1"
                    style={{ backgroundColor: "#009374", outline: "none", border: "none", color: "#fff", maxWidth: "100%", fontSize: "1.2rem" }}
                    onClick={() => handleButtonClick(1)}
                    className="rounded-pill w-100 mt-auto"
                  >
                    Projektmanager
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col xs="12" sm="6" md="6" lg="6">
              <Card className="custom-card">
                <Card.Body>
                  <Card.Text>
                    "Spielen Sie als Systemingnieur, ohne Zeitlimit. Nach Ablauf der Zeit führen Sie das Projekt weiter und nehmen weitere Tätigkeiten vor. Das Projekt endet nur mit einem verifizierten und validierten Prototypen."
                  </Card.Text>
                  <Button
                    value="2"
                    style={{ backgroundColor: "#009374", outline: "none", border: "none", color: "#fff", maxWidth: "100%", fontSize: "1.2rem" }}
                    onClick={() => handleButtonClick(2)}
                    className="rounded-pill w-100 mt-auto"
                  >
                    Systemingenieur
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Mode;
